var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"centered":"","no-fade":"","no-close-on-backdrop":"","no-close-on-esc":"","hide-footer":"","title":_vm.$t('fileManager.upload'),"visible":"","lazy":"","body-class":"p-1"},on:{"hide":_vm.emitClose}},[_c('uploader',{attrs:{"doc-upload-model":_vm.uploadModel,"accept":_vm.accept},on:{"change":_vm.emitClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }